/**
 * Constants for campaign zone label positioning
 */

// Debug mode - set to true to see positioning calculations in console
export const DEBUG_LABEL_POSITIONING = false;

// Visual debug mode - renders debug overlays on the canvas
export const DEBUG_VISUAL_OVERLAY = false;

// Label dimensions in SCREEN pixels (not canvas pixels)
// These should match the actual rendered label size
// Label has: padding 4px 10px, icon 14px, gap 6px, text up to 150px max
// Max width: 10 + 14 + 6 + 150 + 10 + 2 (border) = 192px wide
// Height: 14 + 8 + 2 (border) = ~28px tall
// Using max width to ensure labels never protrude past zone edges
export const LABEL_WIDTH = 192;
export const LABEL_HEIGHT = 28;

// Minimum distance between label candidates along an edge (in canvas pixels)
export const CANDIDATE_STEP = 40;

// Hysteresis threshold - only switch positions if the new one is significantly better
// Higher value = less jitter but slower response to changes
export const HYSTERESIS_THRESHOLD = 120;

// Minimum visible area ratio for a label to be considered "visible"
// Set high (0.95) so labels reposition before ANY edge goes off-screen
export const MIN_VISIBLE_RATIO = 0.95;

// Extra padding around HUD exclusion zones (in screen pixels)
// This makes labels move BEFORE they would touch the HUD
export const EXCLUSION_ZONE_PADDING = 15;

// CSS selectors for HUD elements that labels should avoid
// These are queried at runtime to get actual bounding boxes
export const HUD_ELEMENT_SELECTORS = [
  '.flowchart-hud__glass-card',           // Title card, missions cards
  '.flowchart-hud__quest-log',            // Quest log container
  '.flowchart-minimap',                   // Minimap
  '.campaign-legend',                     // Campaign legend card
  '.unified-toolbar',                     // Bottom toolbar
];

// Edge priority order for label placement
export const EDGE_PRIORITY = ['top', 'left', 'bottom', 'right'];
